import { render, staticRenderFns } from "./formsInputs.vue?vue&type=template&id=7f756d31&"
import script from "./formsInputs.vue?vue&type=script&lang=js&"
export * from "./formsInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports